module.exports = __webpack_public_path__ + "img/music_note.e170d03f.png";